import { render } from "./Salary.component.vue?vue&type=template&id=2ab577db"
import script from "./Salary.component.vue?vue&type=script&lang=js"
export * from "./Salary.component.vue?vue&type=script&lang=js"

import "./Salary.component.vue?vue&type=style&index=0&id=2ab577db&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
